import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, Observable, of, Subscription } from 'rxjs';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { PaymentServices } from '../_services/payment.services';
import { Payment, PaymentResponse, PaymentItem } from '../_models/payment.model';
import { UserModel } from '../../modules/auth/_models/user.model';
import { AuthService } from '../../modules/auth/_services/auth.service';
import { DecimalPipe, formatNumber} from '@angular/common';
import {NgbModal, ModalDismissReasons, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';

import _, { map } from 'underscore';

enum PaymentStates {
  HasError,
  NoError,
  HasSuccess,
  Init,
  Submitted,
  Finishied,
}

enum PaymentCalc {
    HasError,
    HasSuccess
}

@Component({
  selector: 'app-payments',
  templateUrl: './payments.component.html',
  styleUrls: ['./payments.component.scss']
})
export class PaymentsComponent implements OnInit, OnDestroy {
  user$: Observable<UserModel>;
  _user:UserModel;
  isLoading: boolean;
  loadingModalConfig: NgbModalOptions = {
    backdrop : 'static',
    keyboard : false
  };
  paymentMessage: string;
  templateView: number = 1;
  totalPayment: number = 0.0;
  paymentForm: FormGroup;
  paymentState: PaymentStates = PaymentStates.Init;
  paymentStates = PaymentStates;
  paymentError: PaymentStates = PaymentStates.NoError;
  paymentCalc= PaymentCalc;
  calc: PaymentCalc = PaymentCalc.HasSuccess;
  isLoading$: Observable<boolean>;
  policies: Array<PaymentItem> = [];
  private subscriptions: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
  payment_selected: Payment;
  closeResult: string;
  multipayment: boolean = false;

  constructor(
    public paymentService: PaymentServices,
    private auth: AuthService,
    private fb: FormBuilder,
    private modalService: NgbModal
  ) {

  }

  // angular lifecircle hooks
  ngOnInit(): void {
    const sb1 = this.paymentService.isLoading$.subscribe(res => {
      
      this.isLoading = res
      console.log
    });
    this.subscriptions.push(sb1);

    this.user$ = this.auth.currentUserSubject.asObservable();
    this.user$.subscribe(user=> {
      this._user = user;
    });
    
    this.paymentService.fetch();
/*
    this.paymentService.items$.subscribe( (items : Payment[]) => {
      items.forEach(e => {
        this.totalPayment += e.Saldo;
      })
    });
*/
    this.initForm();
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.paymentForm.controls;
  }

  get t() {
    return this.totalPayment;
  }

  get p() {
    return this.policies;
  }

  initForm() {

    this.paymentForm = this.fb.group({
      card_number : [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(16),
          Validators.maxLength(16), // https://stackoverflow.com/questions/386294/what-is-the-maximum-length-of-a-valid-email-address
        ]),
      ],
      firstname: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(30),
        ]),
      ],
      lastname: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(30),
        ]),
      ],
      address: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(100),
        ]),
      ],
      city: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(50),
        ]),
      ],
      state: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(50),
        ]),
      ],
      cvv: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(4),
          Validators.required
        ]),
      ],
      zip: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(12),
        ]),
      ],
      expiration_month: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(2),
        ]),
      ],
      expiration_year: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(2),
        ]),
      ],
    });

  }

  submitPayment(event, paymentModal) {
    this.changeAmount();

    this.paymentState = PaymentStates.Init;

    this.modalService.open(paymentModal, this.loadingModalConfig);

  }

  applyPayment() {
    this.paymentError = PaymentStates.NoError;
    
    var inputs = {
      "first_name": this.f.firstname.value,
      "last_name": this.f.lastname.value,
      "address": this.f.address.value,
      "city": this.f.city.value,
      "state": this.f.state.value,
      "zip": this.f.zip.value,
      "card_number": this.f.card_number.value,
      "expiration": this.f.expiration_month.value + '/' + this.f.expiration_year.value,
      "amount": this.totalPayment,
      "cvv": this.f.cvv.value,
      "CustomerId" : ''
    }; 

    if(!this.multipayment && _.size(this.policies)) {
      inputs.CustomerId = this.policies[0].CustomerId;
    }

    this.paymentService.pay(inputs).then( (response : PaymentResponse) => {
      //console.log(response);
      if(typeof response != undefined) {
        if(typeof response.status != undefined && response.status) {
          this.paymentState = PaymentStates.Submitted;
          
          for(var index = 0; index < this.policies.length; index++){
            this.policies[index].NombreTarjeta = inputs.first_name + ' ' + inputs.last_name;
            this.policies[index].NombrePagador = inputs.first_name + ' ' + inputs.last_name;
            this.policies[index].Reference = response.reference;
            this.policies[index].Autorization = response.autorization;
            this.policies[index].Tracking = response.tracking;
            this.policies[index].Tarjeta = inputs.card_number;
          }

          //console.log(this.policies);

          var data = new FormData();
          data.append("data",  JSON.stringify(this.policies));

          this.paymentService.applyPay(data).then( (response: any) =>{
            if( typeof(response[0].Mensaje) != "undefined") {
                this.paymentMessage = response[0].Mensaje;
            }
          }).finally(()=>{  this.paymentState = PaymentStates.Finishied });

        }
      }
      else {
        this.paymentError = PaymentStates.HasError;
      }
    }).catch( (e) => {
      this.paymentError = PaymentStates.HasError;


    }).finally( () => {

    });
  }

  clickAmount(event, totalAmount, index) {

    var inputTarget = (<HTMLInputElement> document.getElementById("amount"+index));

    if( event.currentTarget.checked && parseFloat(totalAmount) >= 0) {
        inputTarget.value = parseFloat(totalAmount).toString();
    }
    else {
        inputTarget.value = "0.00";
    }

    this.changeAmount(index);
  }

  changeAmount(selected = 0) {
    var amount = 0.00;
    this.policies = [];
    this.calc = this.paymentCalc.HasSuccess;

      for(let i = selected; i < this.paymentService.paginator.total; i++ ) {
        if(parseFloat( (<HTMLInputElement> document.getElementById("amount"+i)).value ) > 0) {
          let data = new PaymentItem();
          data.IdPoliza    = (<HTMLInputElement> document.getElementById("idPolicie"+i)).value;
          data.CustomerId   = (<HTMLInputElement> document.getElementById("numPolicie"+i)).value;
          data.Monto       = parseFloat( (<HTMLInputElement> document.getElementById("amount"+i)).value );

          this.policies.push(data);

          amount += parseFloat( (<HTMLInputElement> document.getElementById("amount"+i)).value );

          if(parseFloat( (<HTMLInputElement> document.getElementById("amount"+i)).value ) > parseFloat( (<HTMLInputElement> document.getElementById("realDueAmount"+i)).value) ) {
              this.calc = this.paymentCalc.HasError;
              (<HTMLInputElement> document.getElementById("amount"+i)).classList.add("hasError");
          }
          else {
              (<HTMLInputElement> document.getElementById("amount"+i)).classList.remove("hasError");
          }
        }

        if(!this.multipayment) {
          console.log(this.policies)
          break;
        }
      }

    this.totalPayment = amount;
  }
}